import { useSelector } from 'react-redux';

import SystemNotice from './system-notice/SystemNotice';

import './system-notices.scss';

const SystemNotices = () => {
  const { notices } = useSelector(({ system }) => system);

  return (
    <div className="system-notices">
      {notices.map((notice) => {
        return <SystemNotice key={notice.id} notice={notice} />;
      })}
    </div>
  );
};

export default SystemNotices;
